import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { ToastModule } from 'primeng/toast';

import { AccordionModule } from 'primeng/accordion';
import { AlertComponent } from './alert/alert.component';
import { AvatarModule } from 'primeng/avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ContentLoaderComponent } from './content-loader/content-loader.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { EditorModule } from 'primeng/editor';
import { ErrorInterceptor } from './helpers/error-interceptor';
import { InputTextModule } from 'primeng/inputtext';
import { JwtInterceptor } from './helpers/jwt-interceptor';
import { MenuModule } from 'primeng/menu';
import { MenubarComponent } from './menubar/menubar.component';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { ToolbarModule } from 'primeng/toolbar';
import { RouterModule } from '@angular/router';
import { DataGridComponent } from './data-grid/data-grid.component';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password'; // <-- Add this
import { SelectModule } from 'primeng/select';

@NgModule({
  declarations: [AlertComponent, BreadcrumbComponent, ContentLoaderComponent, MenubarComponent, DataGridComponent],
  imports: [
    AccordionModule,
    AvatarModule,
    AutoCompleteModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    CommonModule,
    ConfirmDialogModule,
    DataViewModule,
    DialogModule,
    EditorModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    MenuModule,
    MenubarModule,
    MultiSelectModule,
    PanelModule,
    PaginatorModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ReactiveFormsModule,
    RippleModule,
    SelectModule,
    SplitButtonModule,
    SplitterModule,
    TableModule,
    ToastModule,
    ToolbarModule,
    TranslatePipe,
    RouterModule,
  ],
  exports: [
    AccordionModule,
    AutoCompleteModule,
    AlertComponent,
    AvatarModule,
    BadgeModule,
    BreadcrumbComponent,
    BreadcrumbModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    ContentLoaderComponent,
    ConfirmDialogModule,
    DataViewModule,
    DialogModule,
    PasswordModule,
    EditorModule,
    FormsModule,
    DataGridComponent,
    MenubarComponent,
    MultiSelectModule,
    PanelModule,
    PaginatorModule,
    RadioButtonModule,
    ReactiveFormsModule,
    SelectModule,
    SplitButtonModule,
    SplitterModule,
    TableModule,
    TagModule,
    ToastModule,
    ToolbarModule,
    TranslatePipe,
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
})
export class SharedModule {}
